import { createInstance } from '@optimizely/react-sdk';
import type { ReactSDKClient } from '@optimizely/react-sdk';

declare global {
	interface Window {
		__fshrOptimizelyClient?: ReactSDKClient;
	}
}

export function getOrCreateClient(sdkKey: string): ReactSDKClient {
	if (typeof window !== 'undefined' && window.__fshrOptimizelyClient) {
		return window.__fshrOptimizelyClient;
	}
	const client = createInstance({
		sdkKey,
		logger: { log: () => {} },
	});
	if (typeof window !== 'undefined') {
		window.__fshrOptimizelyClient = client;
	}
	return client;
}
